import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=f8b532a4&scoped=true"
import script from "./Placeholder.vue?vue&type=script&lang=ts"
export * from "./Placeholder.vue?vue&type=script&lang=ts"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=f8b532a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b532a4",
  null
  
)

export default component.exports